var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g({class:{ 'no-bg': _vm.buttonText },attrs:{"href":"#","title":_vm.formType === 'login' ? 'Login with LinkedIn' : 'Sign up with LinkedIn',"rel":"nofollow"}},_vm.formType === 'login' ? { click: _vm.linkedinLogin } : { click: _vm.socialSignUp }),[(_vm.buttonText)?[_c('IconLinkedin'),_vm._v(" "+_vm._s(_vm.buttonText)+"\n  ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }